import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true,
});

export const joinWaitlist = async ({ email, source = 'homepage', tier = null, product_slug = null }) => {
    const { data } = await api.post('/waitlist', { email, source, tier, product_slug });
    return data;
};

export const fetchWaitlistStats = async () => {
    const { data } = await api.get('/waitlist/stats');
    return data;
};

export const fetchProducts = async ({ category, featured, active = true } = {}) => {
    const params = {};
    if (category) params.category = category;
    if (featured !== undefined) params.featured = featured;
    if (active !== undefined) params.active = active;
    const { data } = await api.get('/products', { params });
    return data;
};

export const fetchProduct = async (slug) => {
    const { data } = await api.get(`/products/${slug}`);
    return data;
};

export const fetchLogEntries = async ({ published = true } = {}) => {
    const { data } = await api.get('/log', { params: { published } });
    return data;
};

export const fetchLogEntry = async (entryNumber) => {
    const { data } = await api.get(`/log/${entryNumber}`);
    return data;
};

export const fetchLibraryMeta = async () => {
    const { data } = await api.get('/library/categories');
    return data;
};

export const fetchResources = async ({
    category,
    resource_type,
    featured,
    q,
    published = true,
} = {}) => {
    const params = { published };
    if (category) params.category = category;
    if (resource_type) params.resource_type = resource_type;
    if (featured !== undefined) params.featured = featured;
    if (q) params.q = q;
    const { data } = await api.get('/library', { params });
    return data;
};

export const fetchResource = async (slug) => {
    const { data } = await api.get(`/library/${slug}`);
    return data;
};
